import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Col, Row, FormGroup } from 'reactstrap';
import Button from 'components/buttons/Button';
import { withStyles } from '@material-ui/styles';

import { requiredValidator } from 'utils/validators';
import RenderFormInput from 'components/forms/RenderFormInput';

const styles = theme => ({
  label: {
    color: theme.palette.secondary.text,
    fontSize: '0.875rem',
  },
});

const EmailSettingsForm = (props) => {
  const { classes } = props;
  return (
    <form onSubmit={props.handleSubmit}>
      <Row>
        <Col lg={6} xl={5}>
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label
              className={`${classes.label} col-sm-5`}
              htmlFor="maxEmails"
            >
              Max number of emails to a single contact per day
            </label>
            <Col sm={7}>
              <Field
                maxLength="255"
                className="input--inline"
                name="maxEmails"
                component={RenderFormInput}
                type="number"
                step="1"
                min="0"
                validate={[requiredValidator]}
              />
              <span className="grey">emails</span>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Button
        color="primary"
        variant="outlined"
        type="submit"
        disabled={props.pristine || props.submitting}
      >
        Save
      </Button>
    </form>
  );
};


EmailSettingsForm.propTypes = {
  classes: PropTypes.element.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};


EmailSettingsForm.defaultProps = {
  submitting: false,
  pristine: true,
};


export default compose(
  withStyles(styles),
  connect(
    state => ({
      initialValues: {
        maxEmails: state.account.max_emails_to_a_contact_per_day || '0',
      },
    }),
    { },
  ),
  reduxForm({
    form: 'accountEmailSettingsForm',
    enableReinitialize: true,
  }),
)(EmailSettingsForm);
